module.exports = __webpack_public_path__ + "img/pro_thirteen_6.23e7535d.jpg";